const accountSubmenuUOpen = () => {
  const accountSubmenuHandler = document.querySelector(".account-submenu-opener");
  const accountSubmenu = document.querySelector(".account-submenu");
  accountSubmenuHandler.addEventListener('click', (e) => {
    e.preventDefault();
    accountSubmenuHandler.classList.toggle("active");
    accountSubmenu.classList.toggle('active');
    $(".header__submenu").removeClass("active");
    $(".header-submenu-opener").removeClass("opened");
  });

  $(".account-submenu-opener").click(function (e) {
    e.stopPropagation();
  });

  $(".account-submenu").click(function (e) {
    e.stopPropagation();
  });

  $(document).click(function () {
    $(".account-submenu-opener").removeClass("active");
    $(".account-submenu").removeClass("active");
  });
}
$(window).on("scroll", function () {
  if ($(document).scrollTop() > 120) {
    $('body').addClass('onscroll')
  } else if ($(document).scrollTop() < 120) {
    $("body").removeClass("onscroll");
  }
});
document.querySelector(".account-submenu-opener") ? accountSubmenuUOpen() : null;

const menuOpen = document.querySelector(".menu-drawer-open");
const sideMenuOpen = document.querySelector(".side-menu-open");
const sideMenu = document.querySelector(".mobile-drawer-menu");
const sideMegaMenu = document.querySelector(".side-mega-menu");
const layerMenu = document.querySelector(".menu-drawer-overlay");
const megaLayer = document.querySelector(".side_menu_layer");
const bodyn = document.querySelector("html");
const mainn = document.querySelector("main");
const header = document.querySelector("header");
const submenuOpener = document.querySelectorAll(".drawer-submenu-open");
const drawerSubmenu = document.querySelectorAll(".menu-drawer__submenu");
const drawerClose = document.querySelectorAll(".drawer-sub-close");
const drawerAccountClose = document.querySelector(".drawer-account-close");
const drawerAccountSubmenu = document.querySelector(".account-drawer-submenu");
const drawer_accountOpener = document.querySelector(".menu-drawer__account");

submenuOpener.forEach((e) => {
  e.addEventListener("click", (e) => {
    e.target.nextElementSibling.classList.add("active");
  });
});

drawer_accountOpener.addEventListener("click", (e) => {
  e.preventDefault();
  drawerAccountSubmenu.classList.add("active");
});

drawerClose.forEach((e) => {
  e.addEventListener("click", (e) => {
    e.target.parentElement.parentElement.classList.remove("active");
  });
});

drawerAccountClose.addEventListener("click", (e) => {
  drawerAccountSubmenu.classList.remove("active");
});


$(".header-submenu-opener ").click(function () {
  $(this).next(".header__submenu").toggleClass('active')
  $(this).toggleClass('opened');
  $(".account-submenu-opener").removeClass("active");
  $(".account-submenu").removeClass("active");
});

$(".header-submenu-opener").click(function (e) {
  e.stopPropagation();
});

$(".header__submenu").click(function (e) {
  e.stopPropagation();
});

$(document).click(function () {
  $(".header__submenu").removeClass("active");
  $(".header-submenu-opener").removeClass("opened");
});


menuOpen.addEventListener("click", () => {
  sideMenu.classList.add("active");
  layerMenu.style.display = "block";

  bodyn.classList.add("overflow-hidden");
  mainn.classList.add("transform-240");
  header.classList.add("transform-240");
});
layerMenu.addEventListener("click", () => {
  sideMenu.classList.remove("active");
  layerMenu.style.display = "none";
  bodyn.classList.remove("overflow-hidden");
  mainn.classList.remove("transform-240");
  header.classList.remove("transform-240");
});


sideMenuOpen ? sideMenuOpen.addEventListener("click", () => {
  if (!sideMegaMenu.classList.contains('active')) {
    document.getElementById('shopify-section-header')?.setAttribute('data-prevent-scroll', true);
  }
  $(".account-submenu-opener").removeClass("active");
  $(".account-submenu").removeClass("active");
  $(".header__submenu").removeClass("active");
  $(".header-submenu-opener").removeClass("opened");
  sideMegaMenu.classList.toggle("active");
  if (megaLayer.style.display === "none") {
    megaLayer.style.display = "block";
  } else {
    megaLayer.style.display = "none";
  }
  bodyn.classList.toggle("overflow-hidden");
  if (!sideMegaMenu.classList.contains('active')) {
    document.getElementById('shopify-section-header')?.setAttribute('data-prevent-scroll', true);
  }
}) : null;

megaLayer ? megaLayer.addEventListener("click", () => {
  sideMegaMenu.classList.remove("active");
  megaLayer.style.display = "none";
  bodyn.classList.remove("overflow-hidden");
  document.getElementById('shopify-section-header')?.removeAttribute('data-prevent-scroll');
}) : null;

sideMenuOpen ? sideMenuOpen.addEventListener("click", (e) => {
  e.stopPropagation();
}) : null;




sideMegaMenu
  ? sideMegaMenu.addEventListener("click", (e) => {
    e.stopPropagation();
  })
  : null;
menuOpen.addEventListener("click", (e) => {
  e.stopPropagation();
});

submenuOpener.forEach((e) => {
  e.addEventListener("click", (e) => {
    e.stopPropagation();
  });
});

document.addEventListener("click", () => {
  if (sideMegaMenu) {
    sideMegaMenu.classList.remove("active");
    megaLayer.style.display = "none";
    bodyn.classList.remove("overflow-hidden");
  }


  document.getElementById('shopify-section-header')?.removeAttribute('data-prevent-scroll');
});

window.addEventListener("load", (event) => {
  document.querySelector(".tl-inner").style.display = "none";
});


$(document).on("click", ".tl-selections", function () {
  const langpopupTitle = $(".header-language").attr("data-title");
  const langpopupDesc = $(".header-language").attr("data-desc");
  $(".tl-inner").append(
    `<div class='language-popup-titles'><h2> ${langpopupTitle} </h2><div class=''> ${langpopupDesc} </div> </div>`
  );
});


window.TranslationLab.fantomSelectors = (wrapper) => {

  // Add "apply button"
  let applyButton = `
    <div class="tl-apply-button__wrapper"><button class="tl-apply-button">${wrapper.dataset.applyText}</button></div>
  `
  wrapper.querySelector('.tl-inner').insertAdjacentHTML('beforeEnd', applyButton)

  // Create fantom selectors
  let forms = wrapper.querySelectorAll('.shopify-localization-form')
  forms.forEach((form) => {

    let initCC = form.querySelector('input[name="country_code"]').value
    let initLC = form.querySelector('input[name="language_code"]').value

    const tl_select = form.querySelector('.tl-select')
    const tl_options = form.querySelector('.tl-options')
    const switcher = form.closest('.tl-switcher')

    const div = document.createElement('div')
    div.classList.add('tl-select__fantom')

    if (switcher.classList.contains('tl-language')) {
      div.dataset.language = ''
      div.dataset.value = initLC
    }
    else {
      div.dataset.currency = ''
      div.dataset.value = initCC
    }

    div.innerHTML = tl_select.outerHTML + tl_options.outerHTML
    switcher.insertAdjacentHTML('afterbegin', div.outerHTML)

    tl_select.style.display = 'none'
  })


  // Set fantom selectors
  let fantoms = wrapper.querySelectorAll('.tl-select__fantom')
  fantoms.forEach((fantom) => {
    const tl_select = fantom.querySelector('.tl-select')
    const tl_options = fantom.querySelector('.tl-options')
    tl_select.addEventListener('click', () => {
      tl_select.classList.toggle('open')
      tl_options.classList.toggle('open')
    })

    tl_options.querySelectorAll('.tl-option').forEach((option) => {
      option.addEventListener('click', () => {
        tl_select.innerHTML = option.innerHTML
        tl_select.classList.remove('open')
        tl_options.classList.remove('open')

        fantom.dataset.value = option.dataset.value

        forms.forEach((form) => {
          form.querySelector('input[name="country_code"]').value = wrapper.querySelector('.tl-select__fantom[data-currency]').dataset.value
          form.querySelector('input[name="language_code"]').value = wrapper.querySelector('.tl-select__fantom[data-language]').dataset.value
        })

      })
    })
  })

  wrapper.querySelector('.tl-apply-button').addEventListener('click', () => {
    forms[0].submit();
  })

};

$(document).ready(function () {
  if (window.TranslationLab.switcherSettings) {
    window.TranslationLab.fantomSelectors(document.querySelector('.header-language'));
    window.TranslationLab.fantomSelectors(document.querySelector('.mobile-language'));
  }
})



// $(document).on("click", ".tl-overlay", function (e) {
//   $('input[name="country_code"]').on('change', setListenerOnCountryCode);
//   $('input[name="language_code"]').on('change', setListenerOnCountryCode);
// });

// function setListenerOnCountryCode(e) {
//     e.preventDefault();
// }

// window.addEventListener('tlSwitcherReady', function () {
// })

const documentHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", documentHeight);
documentHeight();


const mouseTarget = document.querySelector('.account-menu-container');
const accountOpenerMouse = document.querySelector('.account-submenu-opener');
const accountDropdownMouse = document.querySelector('.account-submenu');
const headerHasSubmenu = document.querySelectorAll('.has-submenu-header');


mouseTarget.addEventListener('mouseleave', (e) => {
  accountOpenerMouse.classList.remove('active');
  accountDropdownMouse.classList.remove('active');
});

headerHasSubmenu.forEach(el => {
  el.addEventListener('mouseleave', (e) => {
    e.target.children[0].classList.remove('opened');
    e.target.children[1].classList.remove('active');
  });
});

$('.product-faq-item__question').on('click', function (e) {
  e.preventDefault();
  var $this = $(this);

  if (!$this.hasClass('active')) {
    $(this).parents('.product-faq-item').find('.product-faq-item__answer').slideUp();
    $(this).parents('.product-faq-item').find('.product-faq-item__question').removeClass('active');
  }

  $this.toggleClass('active');
  $this.next('.product-faq-item__answer').slideToggle();
});


